<template>
  <div class="coinstreamPage">
    <mu-appbar title="交易记录">
      <div slot="right" class="title-text" @click="open('top')" >
        <p>筛选 </p>    
        <mu-popup position="top" popupClass="coinstreamPage-popup" :open="topPopup" @close="close('top')">
          <mu-content-block>
            <div class="popuptitle delivery-type-order">
              <div class="button-title">交易类型</div>
              <div class="button-list">                  
                <mu-flat-button @click="searchTypeChange(0)" label="全部" :class="searchInfo.traceType==0?'demo-flat-button select':'demo-flat-button'"/>
                <mu-flat-button @click="searchTypeChange(1)" label="充值" :class="searchInfo.traceType==1?'demo-flat-button select':'demo-flat-button'"/>
                <mu-flat-button v-if="isCoinTransfer" @click="searchTypeChange(8)" label="转入" :class="searchInfo.traceType==8?'demo-flat-button select':'demo-flat-button'"/>
                <mu-flat-button v-if="isCoinTransfer" @click="searchTypeChange(7)" label="转出" :class="searchInfo.traceType==7?'demo-flat-button select':'demo-flat-button'"/>
                <mu-flat-button v-if="!closeCoinWithdraw" @click="searchTypeChange(2)" label="提现" :class="searchInfo.traceType==2?'demo-flat-button select':'demo-flat-button'"/>
                <mu-flat-button @click="searchTypeChange(3)" label="支付" :class="searchInfo.traceType==3?'demo-flat-button select':'demo-flat-button'"/>
                <mu-flat-button @click="searchTypeChange(5)" label="退款" :class="searchInfo.traceType==5?'demo-flat-button select':'demo-flat-button'"/>
                <mu-flat-button @click="searchTypeChange(4)" label="零售奖金" :class="searchInfo.traceType==4?'demo-flat-button select':'demo-flat-button'"/>
                <mu-flat-button @click="searchTypeChange(6)" label="招商奖金" :class="searchInfo.traceType==6?'demo-flat-button select':'demo-flat-button'"/>
                <mu-flat-button @click="searchTypeChange(24)" label="批发奖金" :class="searchInfo.traceType==24?'demo-flat-button select':'demo-flat-button'"/>
                <mu-flat-button @click="searchTypeChange(10)" label="物流补贴" :class="searchInfo.traceType==10?'demo-flat-button select':'demo-flat-button'"/>
                <mu-flat-button @click="searchTypeChange(11)" label="招商收益" :class="searchInfo.traceType==11?'demo-flat-button select':'demo-flat-button'"/>
                <mu-flat-button @click="searchTypeChange(12)" label="分红奖金" :class="searchInfo.traceType==12?'demo-flat-button select':'demo-flat-button'"/>
                <mu-flat-button @click="searchTypeChange(20)" label="签到" :class="searchInfo.traceType==20?'demo-flat-button select':'demo-flat-button'"/>
                <mu-flat-button @click="searchTypeChange(21)" label="补签" :class="searchInfo.traceType==21?'demo-flat-button select':'demo-flat-button'"/>
                <mu-flat-button v-if="projectName == 'xurigo'" @click="searchTypeChange(22)" label="团长奖励" :class="searchInfo.traceType==22?'demo-flat-button select':'demo-flat-button'"/>
                <mu-flat-button @click="searchTypeChange(23)" label="货款" :class="searchInfo.traceType==23?'demo-flat-button select':'demo-flat-button'"/>
              </div>
            </div>              
          </mu-content-block>
        </mu-popup>      
      </div>
      <mu-icon-button v-on:click="GoHistory" icon=":fa fa-angle-left" slot="left"/>
    </mu-appbar>   
    

      
      <v-scroll :on-refresh="onRefresh" :on-infinite="onInfinite">
        <div class="gd-content">
          <div class="gd-content-tab-dd" id="list"  v-for="(streamItem,index) in streamList" :key="index">            
            <router-link :to="'/usercenter/coinDetail?traceNo='+ streamItem.TraceNo">
              <dd>
                <table>
                  <tbody>
                    <tr>
                      <td class="first-row" rowspan="2"><img :src="getIconByTraceType(streamItem.TraceType)"></td>
                      <td class="secend-row calcMinus"><span>{{streamItem.TraceTypeName}}&nbsp;&nbsp;<i>{{streamItem.TraceNoName}}</i></span>{{streamItem.PlusMinus+streamItem.Trace_Amt.toFixed(2)}}</td>
                    </tr>
                    <tr>
                      <td class="one-row ">{{streamItem.CreateTimeName}}</td>
                    </tr>
                  </tbody>
                </table>
              </dd>
            </router-link>
          </div>
        </div>
      </v-scroll>
    <XR-toast ref="XRtoast"></XR-toast>
     <XR-PageTip ref="XRPageTip"></XR-PageTip>
  </div>
</template>

<script>
import {ErrorCode} from '../../util/errorcode'
export default {
  data() {
    return {
      loaded :true,
      streamList:[],      
      pageEnd : 0, // 结束页数
      num:15,
      searchInfo:{
        pageIndex : 0, // 开始页数
        pageSize:15,
        traceType:0,
        inOrOut:0
      },
      scrollDone:function(){},      
      topPopup: false    
    };
  },
  mounted :function(){
    this.$postBase(
      this.MOBILE_URL + "/Oauth2/WeChat/wechat.ashx"
      ).then(function(res) {
      if(!res.IsSuccess){
          //ths.$refs.XRtoast.failed(res.Msg, true)
      }else{
          wx.config({
              debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
              appId: res.Data.AppId, // 必填，公众号的唯一标识
              timestamp: res.Data.TimeStamp, // 必填，生成签名的时间戳
              nonceStr: res.Data.NonceStr, // 必填，生成签名的随机串
              signature: res.Data.Sign, // 必填，签名，见附录1
              jsApiList: [] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
          });
          wx.ready(function () {
              WeixinJSBridge.call('hideOptionMenu');
          });
      }
    });
    this.$refs.XRtoast.load()
    this.getStreamInfo(true)
  },
  methods: {
    getIconByTraceType:function(traceType){
      if(traceType == '01'){
        return '/static/icon/recharge.png'
      }
      else if( traceType == '02'){
        return '/static/icon/withdraw.png'
      }
      else if(traceType == '03'){
        return '/static/icon/pay.png'
      }
      else if(traceType == '04' || traceType == '06'||traceType == '10'||traceType == '11'|| traceType == '12' || traceType=='22'|| traceType=='24'){
        return '/static/icon/reward.png'
      }
      else if(traceType == '05'){
        return '/static/icon/refund.png'
      }
      else if(traceType == '07'){
        return '/static/icon/transfer.png'
      } 
      else if(traceType == '08'){
        return '/static/icon/transfer.png'
      }
      else if(traceType == '20'){
        return '/static/icon/reward.png'
      }
      else if(traceType == '21'){
        return '/static/icon/pay.png'
      }
      else if(traceType == '23'){
        return '/static/icon/get.png'
      }
    },
    getStreamInfo: function(isNewSearch) {
     
      if(isNewSearch){        
        this.searchInfo.pageIndex=1
      }
      else{        
        this.searchInfo.pageIndex++
      }
      var ths = this;   
      ths.$post(
        "/Shop/UserServer/GetCoinStreampage",this.searchInfo
      ).then(function(res) {
        ths.scrollDone()
        ths.loaded = false
        ths.$refs.XRtoast.hide()
        if(!res.IsSuccess){
          if(res.TypeId == ErrorCode.SessionMissing){
            ths.$router.push("/Login")
          }
          if(isNewSearch){            
             ths.streamList = []
          }      
        }else{       

          if(isNewSearch){
            ths.streamList =res.Data.List
          }
          else{            
            for(var i = 0; i < res.Data.List.length;i++){            
              ths.streamList.push(res.Data.List[i])
            }
           
          }
          ths.pageEnd = res.Data.Rows%ths.num!=0? res.Data.Rows/ths.num+1:res.Data.Rows/ths.num
        }
        if(ths.streamList.length==0){
          ths.$refs.XRPageTip.ShowEmpty('暂无数据')
        }else{
          ths.$refs.XRPageTip.initTip()
        }
      });
    },    
    open (position) {
       
      this[position + 'Popup'] = true
      this.titleIcon = "fa fa-angle-up";
    },
    close (position) {
      this[position + 'Popup'] = false
      this.titleIcon = "fa fa-angle-down";
    },
    searchTypeChange (val) {
        this.searchInfo.traceType = val
        this.getStreamInfo(true)    
        this.close('top')    
    },  
    searchInOrOutChange (val) {
        this.searchInfo.inOrOut = val
        this.getStreamInfo(true)    
        this.close('top')    
    },   
    GoHistory(){
      this.$router.goBack()
    },
    onRefresh(done) {
      //this.getOrderList();
      done() // call done      
    },
    onInfinite(done) {      
      this.scrollDone = done
      if(this.searchInfo.pageIndex+1 > this.pageEnd){
        done()
        this.$refs.XRtoast.failed("已经到最后一页", true)
        return
      }
      this.getStreamInfo(false);     
    }
  }
};
</script>
<style>
*{
  margin: 0;
  padding: 0;
}
body .coinstreamPage{
  background: white;
  overflow: hidden;
}
.coinstreamPage .yo-scroll{
  background: white;
  top:56px;
}

.coinstreamPage .mu-appbar{
    position: fixed;
    top: 0;
    z-index: 20180101;
}
.coinstreamPage .mu-appbar-title {
    font-size: 16px;
}
.coinstreamPage .right .title-text{
    font-size: 16px;
}

body .coinstreamPage #list{
  padding-top: 10px;
}
body .coinstreamPage .gd-content{
  background: white;
  overflow: hidden;
}
    .coinstreamPage .gd-content table {
        width:96%;
    }
    .coinstreamPage .gd-content table td {
        vertical-align:middle;
    }
        .coinstreamPage .gd-content table td.first-row {
            padding-top:5px;
            width:48px;
            line-height:16px;
            text-align: center;
        }
           .coinstreamPage  .gd-content table td.first-row img {
                width:28px;                
            }

       .coinstreamPage  .gd-content table td.secend-row {
            padding-top:17px;
            line-height:14px;
            text-align:right;
            font-style:normal;
        }
       .coinstreamPage  .gd-content table td.secend-row span{
            float:left;
            color:#8F94A1;
        }
        .coinstreamPage .gd-content table td.one-row {
            padding-bottom:17px;
            border-bottom:1px solid #F6F6F6;
            line-height:14px;
            color:#CDCDCD;
            font-size:12px;
        }
           .coinstreamPage  .gd-content table td.one-row.last {
                border:none;
            }

.coinstreamPage .calcPlus {
    color:red;
}
.coinstreamPage .calcMinus {
    color:#59C2A4;
}

.coinstreamPage .coin-info {
    padding:5px 0 20px;
    text-align:center;
}
    .coinstreamPage .coin-info .balance {
        font-size:24px;
    }
    .coinstreamPage .coin-info .balance-title {
        font-size:12px;
        color:#999;
        padding-top:4px;
    }

    .coinstreamPage-popup {
        width: 100%;
        top:46px;
        height: 360px;
        z-index: 1;
        padding: 20px 0;
    }
    .coinstreamPage-popup .popuptitle .title{
        overflow: hidden;
    }
    .coinstreamPage-popup .popuptitle .button-title{
      padding: 20px 20px 10px;
    }
    .coinstreamPage-popup .popuptitle .title .text{
        float: left; 
        width:20%;
        text-align: center;
        line-height: 24px;
        color:#ccc;
    }
    .coinstreamPage-popup .popuptitle .title .line{
        float: left; 
        height: 1px;
        background:#eee;
        width: 80%;
        border: none;
        margin-top: 10px;
    }
    .coinstreamPage-popup .popuptitle .demo-flat-button.select{
      color:red;
    }
</style>



// WEBPACK FOOTER //
// src/pages/usercenter/coinstream.vue